import { useAuthStore } from '../store/authStore';
import { useBookingStore } from '../store/bookingStore';
import { useNavigation } from './useNavigation';
import { User } from '../models/User';

/**
 * Hook personalizado para autenticación
 * Similar a un AuthService en Angular
 * 
 * Maneja toda la lógica de autenticación
 */
export const useAuth = () => {
  const { isLoggedIn, user, login: loginStore, logout: logoutStore, updateUser } = useAuthStore();
  const clearBooking = useBookingStore((state) => state.clearBooking);
  const { goToHome } = useNavigation();

  const login = (userData: User) => {
    loginStore(userData);
  };

  const logout = () => {
    // Limpiar todo el estado de la aplicación
    logoutStore();
    clearBooking();
    goToHome();
  };

  const updateProfile = (userData: Partial<User>) => {
    updateUser(userData);
  };

  return {
    isLoggedIn,
    user,
    login,
    logout,
    updateProfile,
  };
};
